import { composeProps, createPropsExtender, ifProps, Selector } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { ApplicationState, ProfileData, WithEnterpriseId } from '@mews-commander/types';
import { getEnterpriseProfileData as getEnterpriseProfileDataJS } from '../ducks/enterpriseProfiles';

const getEnterpriseProfileData = getEnterpriseProfileDataJS as Selector<
    ApplicationState,
    Identifiable & WithEnterpriseId,
    ProfileData
>;

export const getCurrentEnterpriseProfileData = composeProps(
    ifProps(['enterpriseId'], getEnterpriseProfileData),
    createPropsExtender<ApplicationState, Identifiable, string | undefined, WithEnterpriseId>(
        'enterpriseId',
        getCurrentEnterpriseId
    )
);
